/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Edit_Event_Group_Max_Lines_LabelInputs */

const en_edit_event_group_max_lines_label = /** @type {(inputs: Edit_Event_Group_Max_Lines_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Max Lines Per Event`)
};

const fr_edit_event_group_max_lines_label = /** @type {(inputs: Edit_Event_Group_Max_Lines_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre maximal de lignes par événement`)
};

const de_edit_event_group_max_lines_label = /** @type {(inputs: Edit_Event_Group_Max_Lines_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maximale Zeilen pro Veranstaltung`)
};

const it_edit_event_group_max_lines_label = /** @type {(inputs: Edit_Event_Group_Max_Lines_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Numero massimo di linee per evento`)
};

const ru_edit_event_group_max_lines_label = /** @type {(inputs: Edit_Event_Group_Max_Lines_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Максимальное количество линий на мероприятие`)
};

const es_edit_event_group_max_lines_label = /** @type {(inputs: Edit_Event_Group_Max_Lines_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Máximo de líneas por evento`)
};

const zh_cn2_edit_event_group_max_lines_label = /** @type {(inputs: Edit_Event_Group_Max_Lines_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每场比赛最多行数`)
};

const ja_edit_event_group_max_lines_label = /** @type {(inputs: Edit_Event_Group_Max_Lines_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントあたりの最大行数`)
};

const hi_edit_event_group_max_lines_label = /** @type {(inputs: Edit_Event_Group_Max_Lines_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रति इवेंट अधिकतम लाइनें`)
};

const pt_pt2_edit_event_group_max_lines_label = /** @type {(inputs: Edit_Event_Group_Max_Lines_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Número máximo de linhas por evento`)
};

/**
* | output |
* | --- |
* | "Max Lines Per Event" |
*
* @param {Edit_Event_Group_Max_Lines_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const edit_event_group_max_lines_label = /** @type {((inputs?: Edit_Event_Group_Max_Lines_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Edit_Event_Group_Max_Lines_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_edit_event_group_max_lines_label(inputs)
	if (locale === "de") return de_edit_event_group_max_lines_label(inputs)
	if (locale === "it") return it_edit_event_group_max_lines_label(inputs)
	if (locale === "ru") return ru_edit_event_group_max_lines_label(inputs)
	if (locale === "es") return es_edit_event_group_max_lines_label(inputs)
	if (locale === "zh-CN") return zh_cn2_edit_event_group_max_lines_label(inputs)
	if (locale === "ja") return ja_edit_event_group_max_lines_label(inputs)
	if (locale === "hi") return hi_edit_event_group_max_lines_label(inputs)
	if (locale === "pt-PT") return pt_pt2_edit_event_group_max_lines_label(inputs)
	return en_edit_event_group_max_lines_label(inputs)
});